import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatFormField, MatLabel, MatOption, MatSelect } from '@angular/material/select';
import { SiaTranslatePipe } from '../../pipes/sia-translate.pipe';
import { notify } from '../../services/notify';

@Component({
  selector: 'perspective-level-dialog',
  standalone: true,
  imports: [
    MatButton,
    MatDialogTitle,
    MatDialogActions,
    MatIconModule,
    MatDialogContent,
    SiaTranslatePipe,
    MatSelect,
    MatFormField,
    MatLabel,
    MatOption,
  ],
  templateUrl: './perspective-level-dialog.component.html',
  styleUrl: './perspective-level-dialog.component.css',
})
export class PerspectiveLevelDialogComponent {
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<PerspectiveLevelDialogComponent>>(MatDialogRef);

  types: { id: string; description: string }[] = [
    { id: 'customer', description: 'Cliente' },
    { id: 'core', description: 'Core' },
  ];
  originalType: string | undefined;

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {
    if (!this.data.iscore) {
      this.types = this.types.filter((t) => t.id !== 'core');
    }
    this.dialogRef.disableClose = false;
    this.originalType = this.data.configuration.levelType;
  }

  save() {
    if (!this.data.configuration.levelType) {
      notify('Seleziona un tipo di livello ', 1500, 'error');
      return;
    }
    if (!(this.originalType === 'core' && this.data.configuration.levelType === 'core')) {
      this.data.configuration.deleteDelta = true;
    }
    this.dialogRef.close(this.data.configuration);
  }
}
